export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./~/rc-pagination/es/index.js
// module id = 2493
// module chunks = 0